module.exports = __webpack_public_path__ + "img/129ne.6e0a0216.svg";